import WithdrawCompletePage from '../../components/pages/accounts/WithdrawCompletePage'
export default {
  components: { WithdrawCompletePage }
}
